// JSON.parse()
var sessionData=  localStorage.getItem('result-status');
// console.log("dasd",typeof sessionData);

if(sessionData === 'true'){
    $(".cart__top .cart__defualt-title").hide();
    const newElement = `
  <div class="cart__replace">
    <h1 class="title title--primary">Your COMPUSHIFT Kit</h1>
    <h6 style="color:blue">CHECK OUT WHAT OUR CUSTOMERS SAY:</h6>
    <h6 style="color:blue">“After watching a few videos online, it was an easy install.” <b>- Darrell S.</b></h6>
    <h6 style="color:blue; padding-bottom:18px">“I love the way you can change programming to tune the transmission directly from your phone or I-pad.” <b>- Doug R.</b></h6>
  </div>
`;
$('.cart__top').append(newElement);
  
  
}else{

    console.log("Not Created Session..");
}
    

$(".header__icon--cart").on("click",function(){
  localStorage.setItem("result-status","false");
})
$(".cart__redirect").on("click",function(){
  localStorage.setItem("result-status","false");
})








































// $(".addToCart__button").on("click",function(){

//   localStorage.setItem("result-status","false");
// })
